import { isEqual } from "date-fns";
import { IWalletLoan } from "../constants/types.ts";
import { errorAlert } from "../constants/alerts.tsx";
import { getNextDueToPay, spMapping, vigencia } from "../constants/commonMapping.ts";

export const manualCollectMapping = (loan: IWalletLoan) => {
  try {
    const dataLocal: any[] = [];

    const dataSp = spMapping(loan);
    let totalCreditDue = dataSp.reduce((acum, data) => acum + data.c2_total, 0);
    let valorMora = totalCreditDue;
    let c200_vlr_cuota =
      parseInt(loan.payment_plans[0].c202_vlr_cuota) +
      loan.payment_plans[0].additional_payment_plan.reduce(
        (acum: number, { c210_vlr_cuota }) => acum + parseInt(c210_vlr_cuota),
        0
      );
    let c200_proxima_cuota = 0;

    //Entra cuando es vigente
    if (
      vigencia(loan).vigencia === 1 ||
      loan.payment_plans.some(({ c202_fecha_cuota }) =>
        isEqual(
          new Date(c202_fecha_cuota).setHours(0, 0, 0, 0),
          new Date().setHours(0, 0, 0, 0)
        )
      )
    ) {
      const nextPaymentPlan = getNextDueToPay(loan);
      //Si es vigente se suma el valor de la cuota al valor del saldo en mora al dia
      if (nextPaymentPlan.c202_ind_estado === "0") {
        totalCreditDue +=
          parseInt(nextPaymentPlan.c202_vlr_cuota) +
          nextPaymentPlan.additional_payment_plan.reduce(
            (acum: number, { c210_vlr_cuota }) =>
              acum + parseInt(c210_vlr_cuota),
            0
          );
      } else if (nextPaymentPlan.c202_ind_estado === "2") {
        totalCreditDue += parseInt(
          loan.banking_transaction.find(
            ({ c230_ind_estado }) => c230_ind_estado === "2"
          )!.c230_valor_pendiente
        );
      }

      c200_proxima_cuota = totalCreditDue;
    } else {
      //Entra cuando no es vigente
      c200_proxima_cuota = valorMora;
    }

    const flag = loan.payment_plans.some(
      ({ c202_ind_estado }) =>
        c202_ind_estado.toString() === "2" || c202_ind_estado.toString() === "0"
    );

    //Si el valor de la mora es mayor a cero o hay una cuota por pagar se muestra el resultado
    if (valorMora !== 0 || flag) {
      dataLocal.push({
        c200_rowid: loan.c200_rowid,
        c200_vlr_cuota,
        c120_rowid: loan.third.c120_rowid,
        c120_razon_social: loan.third.c120_razon_social,
        c200_proxima_cuota,
        valorMora,
        c120_nit: loan.third.c120_nit,
        c231_fecha_transaccion:
          loan.banking_transaction_extension.length > 0
            ? new Date(
              loan.banking_transaction_extension[0].c231_fecha_transaccion
            ).toLocaleDateString("es-CO", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })
            : "-",
      });
    }

    return dataLocal;
  } catch (error: any) {
    errorAlert(
      "Ha ocurrido un error",
      "El proceso no puede llevarse a cabo en este momento, por favor comunicarse con el desarrollador de planta",
      error.name + " - " + error.message
    );

    return [];
  }
};
